import {
    Logger,
    LogLevel,
    DebugManager,
    LogExporter,
    SearchParamsTrigger,
    DebugModeSyncTrigger,
    SessionTrigger,
    ShortcutTrigger,
    ShakeTrigger
} from '@fx-ui/web-log';
import Intl from '@fx-ui/intl';
import { Message } from '@fx-ui/fine-design';
import { isWeChatOrWxWorkUA, isMobileUA } from '~/utils';
import { h5JsApi } from './h5-jsapi';

// 是否是首次开启调试模式
let isFirstOpenDebugMode = true;

export const logger = new Logger({
    maxObjectDepth: 4,
    beforeClose: () => {
        // 销毁调试管理器
        debugManager.destroy();
        // 销毁日志导出器
        logExporter.destroy();
    },
    shouldLogInConsole: () => {
        return debugManager.getDebugMode();
    }
});

// 初始化调试管理器
export const debugManager = new DebugManager({
    registerTriggers: (debugManager) => {
        const afterTriggerToggle = () => {
            if (debugManager.getDebugMode()) {
                let debugModeTip;
                if (isWeChatOrWxWorkUA() && isFirstOpenDebugMode) {
                    // 微信或企微环境下首次开启日志调试模式后，需要提示用户刷新页面后才能开启sdk调试
                    debugModeTip = Intl.get('log.debug.open.refresh');
                } else {
                    debugModeTip = Intl.get('log.debug.open');
                }
                isFirstOpenDebugMode = false;
                Message.success(debugModeTip);
            }
        };

        /**
         * 监听摇一摇动作（仅在测试环境下开启，且通过 BUILD_ENV 环境变量来判断是否为测试环境）
         * 注意，调试开发时，如果修改了 package.json 中的构建命令的 BUILD_ENV 值，
         * 每次都需要删除 node_modules 目录下的 .cache 目录，并重新运行构建命令，否则
         * BUILD_ENV 的值可能会不按预期生效
         */
        const isTestEnv = BUILD_ENV === 'test';
        const debugTriggers = [
            new SearchParamsTrigger(),
            new SessionTrigger({ debugManager }),
            new ShortcutTrigger({
                hooks: {
                    afterToggle: afterTriggerToggle
                }
            })
        ];

        if (isTestEnv && isMobileUA()) {
            return [
                ...debugTriggers,
                new ShakeTrigger({
                    hooks: {
                        afterToggle: () => {
                            afterTriggerToggle();
                            // 触发时提供振动反馈（如设备支持）
                            if (navigator.vibrate) {
                                navigator.vibrate(100);
                            }
                        }
                    }
                })
            ];
        }

        return debugTriggers;
    }
});

debugManager.registerListener((isDebugMode) => {
    h5JsApi.setIsDebug(isDebugMode);
});

// 初始化日志导出器
const logExporter = new LogExporter({
    logCollector: logger.exportLogs.bind(logger),
    triggers: [new DebugModeSyncTrigger({ debugManager })],
    hooks: {
        onExportSuccess() {
            logger.info('logs export success');
        },
        onExportFail(err) {
            logger.error('logs export failed', { err });
            Message.error(`${Intl.get('log.export.fail.tip')}: ${err?.message}`);
        }
    }
});

/**
 * SDK场景下的专属日志记录
 * 自带默认命名空间 'sdk'，且日志级别默认为 DEBUG
 */
export const sdkLogger = logger.createNamespacedLogger('sdk', LogLevel.DEBUG);
